import { format, isValid, parseJSON } from 'date-fns';

export type DatetimeTextVariant =
  | 'full'
  | 'fullDate'
  | 'short'
  | 'shortDate'
  | 'numeric'
  | 'numericDate'
  | 'day'
  | 'month'
  | 'ordinal'
  | 'time'
  | 'weekday'
  | 'year'
  | 'default'
  | 'json'
  | 'western'
  | 'longDate'
  | 'scheduleDate';

const dateTimeFormatConfig: Record<DatetimeTextVariant, string> = {
  full: 'd MMMM yyyy, HH:mm[timeSuffix]', // 2 January 2020, 14:00
  fullDate: 'd MMMM yyyy', // 2 January 2020
  short: 'd MMM yyyy, HH:mm[timeSuffix]', // 2 Jan 2020 14:00
  shortDate: 'MMMM dd, yyyy', // January 2, 2020
  numeric: 'dd/MM/yyyy HH:mm[timeSuffix]', // 02/01/2020, 14:00
  numericDate: 'dd/MM/yyyy', // 02/01/2020
  day: 'ccc, MMM d', // Tue, Apr 7
  month: 'MMMM yyyy', // January 2020
  ordinal: 'do', // 15th
  time: 'HH:mm[timeSuffix]', // 14:00
  weekday: 'cccc', // Sunday
  year: 'yyyy', // 2020
  default: 'MMM dd, yyyy HH:mm:ss',
  json: `yyyy-MM-dd'T'HH:mm:ss.SSS'Z'`,
  western: 'yyyy-MM-dd',
  longDate: 'MMMM dd, yyyy HH:mm:ss',
  scheduleDate: 'MM/dd/yyyy',
};

export function getDatetimeText(
  date: Date | string,
  variant: DatetimeTextVariant,
  fallback?: string
): string {
  const dateObj = date instanceof Date ? date : parseJSON(date);

  if (fallback !== undefined && !isValid(dateObj)) return fallback;

  try {
    const dateFmt = dateTimeFormatConfig[variant];
    if (!dateFmt) throw new Error(`Unknown variant: ${variant}`);
    return format(dateObj, dateFmt);
  } catch (err) {
    return fallback || err;
  }
}
